import { defineStore } from 'pinia'
import { getEnvironmentLabel } from '@/globals/typescript/utils/host'

export const useAppStore = defineStore('app', {
  state: () => ({
    appVersion: import.meta.env.VITE_APP_VERSION as string,
    appMode: getEnvironmentLabel(),
    defaultMessageSaveIconTime: 1500 as number,
  }),
})

